import React, { useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import AssistCallsTable from 'components/admin/assist/AssistCallsTable';
import Tabs from 'components/common/tabsTable/TabsTable';
import './Communication.scss';
import SmsUsageLimitsTable from './SmsUsageLimitsTable';

export const COMMUNICATION_PATH = '/communication';
export const COMMUNICATION_CALLS_PATH = '/communication/calls';
export const COMMUNICATION_USAGE_LIMITS_PATH = '/communication/usage-limits';

const TAB_PATHS = [COMMUNICATION_CALLS_PATH, COMMUNICATION_USAGE_LIMITS_PATH];

const Communication: React.FC = () => {
  const history = useHistory();
  const { pathname } = useLocation();

  const tabValueSelected = Math.max(TAB_PATHS.indexOf(pathname), 0);

  const tabsData = useMemo(
    () => [
      { name: 'Calls list', value: 'calls', children: <AssistCallsTable /> },
      { name: 'Usage limits', value: 'usage-limits', children: <SmsUsageLimitsTable /> },
    ],
    [],
  );

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    history.push(TAB_PATHS[newValue]);
  };

  return (
    <div className="page-container communication-page">
      <div className="communication-header">
        <h1>Communication</h1>
      </div>

      <Tabs
        tabsData={tabsData}
        tabValueSelected={tabValueSelected}
        handleTabChange={handleTabChange}
      />
    </div>
  );
};

export default Communication;
